import Controller from "./editableDate.controller";
import template from "./editableDate.html";

const editableDate = {
  template,
  controller: Controller,
  bindings: {
    selected: "=",
    title: "@",
    eventName: "<",
    showRemove: "<",
    withTime: "@",
    dateFormat: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    permissionName: "@",
    extraParams: "<",
    minDate: "<",
    hideEdit: "<",
  },
};

export default editableDate;



// WEBPACK FOOTER //
// ./src/components/editableDate/editableDate.component.js